<template>
  <a-config-provider :locale="pl_PL">
    <div class="pagination mt-48 mb-48">
      <a-row type="flex" justify="center">
        <a-col>
          <a-pagination
            v-model="current"
            :defaultCurrent="1"
            :total="ccount"
            @change="changePage"
            :defaultPageSize="12"
            :itemRender="itemRender"
          />
        </a-col>
      </a-row>
    </div>
  </a-config-provider>
</template>

<script>
import pl_PL from "ant-design-vue/lib/locale-provider/pl_PL";
import moment from "moment";
import "moment/locale/pl";
moment.locale("pl");

export default {
  props: {
    ccount: Number
  },
  data: () => ({
    pl_PL,
    current: 1,
    dparams: "",
    latch: 0,
    dContexts: [
      "/oferta/szukaj.xml",
      "/wyjazdy/oferty.xml",
      "/wakacje/oferty.xml",
      "/last-minute/oferty.xml"
    ]
  }),
  methods: {
    itemRender(current, type, originalElement) {
      let path = this.$route.path;

      if (type === "page") {
        originalElement = this.$createElement(
          "a",
          {
            attrs: {
              href: current != 1 ? path + "?page=" + current : path,
              title: "Strona " + current
            },
            on: {
              click(e) {
                e.preventDefault();
              }
            }
          },
          current
        );
      }
      return originalElement;
    },
    changePage(page, pageSize) {
      console.log("Page:" + page);
      var cContext = this.$route.path;
      console.log("Current Context:" + cContext);
      if (this.dContexts.includes(cContext)) {
        console.log("Context is valid. Continueing...");
      } else if (
        cContext.indexOf("/wyjazdy/") !== -1 ||
        cContext.indexOf("/wakacje/") !== -1 ||
        cContext.indexOf("/last-minute/") !== -1 ||
        cContext.indexOf("/rodzaj-oferty/") !== -1
      ) {
        console.log("Context is still valid. Continueing...");
      } else {
        cContext = this.dContexts[0];
      }
      this.current = page;
      this.latch = 1;
      this.getQueryParams(false);
      this.$router.push({ path: cContext + "?" + this.dparams });
      this.scrollToTop();
    },
    getQueryParams(flag) {
      let lparams = this.$route.query;
      //console.log(lparams);
      if (flag && lparams["page"]) {
        this.current = Number(lparams["page"]);
      }
      let qs = Object.keys(lparams)
        .filter(key => key != "page")
        .map(key => {
          return (
            encodeURIComponent(key) + "=" + encodeURIComponent(lparams[key])
          );
        })
        .join("&");
      // this.dparams = "page=" + this.current + "&" + qs;
      this.dparams = qs + "&" + "page=" + this.current;
    },
    scrollToTop() {
      const resultsHeader = this.$parent.$refs.resultsHeader;
      resultsHeader.scrollIntoView({ behavior: "smooth" });
    }
  },
  mounted() {
    this.getQueryParams(true);
  },
  watch: {
    $route(to, from) {
      if (this.latch > 0) {
        this.latch -= 1;
      } else {
        console.log("Out of Latch, ouch...");
        this.getQueryParams(true);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep {
  .ant-pagination-item,
  .ant-pagination-prev,
  .ant-pagination-next,
  .ant-pagination-prev,
  .ant-pagination-next,
  .ant-pagination-jump-prev,
  .ant-pagination-jump-next {
    @media (max-width: $screen-xxxs-max) {
      line-height: 32px;
      height: 32px;
      min-width: 32px;
    }

    line-height: 35px;
    height: 36px;
    min-width: 36px;
  }

  .ant-pagination-item:not(.ant-pagination-item-active),
  .ant-pagination-prev .ant-pagination-item-link,
  .ant-pagination-next .ant-pagination-item-link {
    border-color: $border-color;
  }

  .ant-pagination-item-active,
  .ant-pagination-item:focus,
  .ant-pagination-item:hover,
  .ant-pagination-prev:hover a,
  .ant-pagination-next:hover a {
    border-color: darken(#f2f8ff, 20%);
  }

  .ant-pagination-item-active a,
  .ant-pagination-item:focus a,
  .ant-pagination-item:hover a,
  .ant-pagination-prev:focus .ant-pagination-item-link,
  .ant-pagination-next:focus .ant-pagination-item-link,
  .ant-pagination-prev:hover .ant-pagination-item-link,
  .ant-pagination-next:hover .ant-pagination-item-link,
  .ant-pagination-jump-prev
    .ant-pagination-item-container
    .ant-pagination-item-link-icon,
  .ant-pagination-jump-next
    .ant-pagination-item-container
    .ant-pagination-item-link-icon {
    color: $link-color;
  }

  .ant-pagination-disabled a,
  .ant-pagination-disabled:hover a,
  .ant-pagination-disabled:focus a,
  .ant-pagination-disabled .ant-pagination-item-link,
  .ant-pagination-disabled:hover .ant-pagination-item-link,
  .ant-pagination-disabled:focus .ant-pagination-item-link {
    color: $border-color;
    border-color: $border-color;
  }

  .ant-pagination-item-active,
  .ant-pagination-item:focus,
  .ant-pagination-item:hover {
    background-color: #f2f8ff;
  }

  @media (max-width: $screen-xxs-max) {
    .ant-pagination {
      margin-right: -6px;
    }
    .ant-pagination-prev,
    .ant-pagination-next {
      display: none;
    }
  }
}
</style>
